import type { MemberContactField } from '../schema/memberContactSchema';

// The Member Contact program unit (ME-1256). Submitting an instance's responses
// is what saves address/phone to the profile AND checks off the MWL checklist
// (backend side effects) — see submitMemberContact.
// URN: urn:vida:program-unit:aa9bb7fc-19b3-4004-b093-b4bf070531aa
export const MEMBER_CONTACT_PROGRAM_UNIT_UUID = 'aa9bb7fc-19b3-4004-b093-b4bf070531aa';

// SYNCED FROM: VidaReactNative/src/features/Content/Survey/constants/programUnitQuestionUuids.ts
// Data-synced, NOT a verbatim file copy: the UUID -> field map below is copied as-is,
// but the surrounding types/exports are onboarding-specific. VRN's `ProgramUnitQuestionKind`
// is `MemberContactField` here, and `getProgramUnitQuestionKind` is `getMemberContactQuestionField`.
// Keep the UUID data in sync; the wrapper can diverge. Each address field has two known UUID
// variants on the backend; both must be matched. See SYNC.md.
const MEMBER_CONTACT_QUESTION_UUIDS: Readonly<Record<string, MemberContactField>> = {
  // addressLine1
  'c263add2-2ffd-42e7-b518-8812e0689a79': 'addressLine1',
  '79dbc3b6-b76c-4018-8084-0727fd06bb3f': 'addressLine1',
  // addressLine2
  'd798e989-719c-4cd0-bd3d-9c31a85453f4': 'addressLine2',
  'a5a87bf0-62c8-4dbb-8390-ce3621fadb15': 'addressLine2',
  // city
  '0d73d32e-4cb6-417e-b277-c7beff49324a': 'city',
  'd4125dda-48fd-45c7-bdf7-ffc8baea6097': 'city',
  // state
  '0044e6ae-7989-40ba-9ac9-727f3421c674': 'state',
  'deeed412-efce-471b-8821-07e8e181386b': 'state',
  // zip
  'eb85c43f-168f-4af5-8db7-e73253d268ee': 'zip',
  'ac9c8d76-b0df-4365-a97c-aafd3c6cd85b': 'zip',
  // phone
  '388de8ab-58e9-43df-8731-813859565f61': 'phone',
};

/** Maps a question UUID to the contact field it collects, or null if unrecognized. */
export const getMemberContactQuestionField = (uuid: string): MemberContactField | null =>
  MEMBER_CONTACT_QUESTION_UUIDS[uuid] ?? null;
